import api from '@api';
import React, { FC, useEffect, useState } from 'react';
import FileDisplay from 'src/components/FileDisplay';
import { FileType } from 'src/types/file';

export interface TransportShipperLabelPropsType {
    idTransport: string;
    handleHideShipperLabel: () => void;
}

const TransportShipperLabel: FC<TransportShipperLabelPropsType> = (props) => {
    const [file, setFile] = useState<FileType | null>(null);

    const loadFileData = async () => {
        const response: { data: { data?: { label: string }; label?: string } } = await api(
            'get',
            `api/secure/transports/${props.idTransport}/shipper-label`
        );
        const label = response.data.data?.label ?? response.data.label;
        if (!label) {
            props.handleHideShipperLabel();
            return;
        }
        if (label.indexOf(';base64,') > -1) {
            setFile({ data: label });
        } else {
            setFile({ data: `data:application/pdf;base64, ${label}` });
        }
    };

    useEffect(() => {
        if (!file) {
            loadFileData();
        }
    }, [file]);

    if (file) {
        return <FileDisplay file={file} onClose={props.handleHideShipperLabel} />;
    }
    return null;
};

export default TransportShipperLabel;
